















































import Vue from "vue";
import moment from "moment";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// Vue Components
import VFaIcon from "@/components/VFaIcon.vue";

// Model
import { EcrDefinitionsInfo } from "@/model/data/ecr/EcrDefinitionsInfo";
import { ecrCodeStatusEnumLabel, EcrCodeStatusEnum } from "@/model/data/ecr/EcrCodeStatusEnum";
import { DownloadEcrListCommand } from "@/model/communication/ecr/DownloadEcrListCommand";

export default Vue.extend({
    components: { VFaIcon },
    data() {
        return {
            moment,
            EcrCodeStatusEnum,
            downloadLoading: false,
            headers: [
                {
                    text: this.$t("ecrCodes.ecrStatus"),
                    value: "ecrStatus",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("common.model"),
                    value: "model",
                },
                {
                    text: this.$t("ecrCodes.sensorHw"),
                    value: "sensorHw",
                },
                {
                    text: this.$t("ecrCodes.sensorSw"),
                    value: "sensorSw",
                },
                {
                    text: this.$t("ecrCodes.ecrCode"),
                    value: "code",
                },
                {
                    text: this.$t("ecrCodes.deviceCategory"),
                    value: "deviceCategory",
                },
                {
                    text: this.$t("ecrCodes.testDate"),
                    value: "testDate",
                },
                {
                    text: this.$t("ecrCodes.expirationDate"),
                    value: "expirationDate",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            availableEcrCodes: (state: RootState): EcrDefinitionsInfo[] => state.fitnessStatistics.availableEcrCodes,
        }),
    },
    methods: {
        ecrCodeStatusEnumLabel,

        async exportAsPdf() {
            if (!this.downloadLoading) {
                this.downloadLoading = true;
                try {
                    const res = await new DownloadEcrListCommand().execute();
                    this.downloadLoading = false;

                    if (res.status == 200) {
                        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
                        var fileLink = document.createElement("a");
                        fileLink.href = fileURL;
                        fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }
                } catch (e) {
                    console.log("Something went wrong", e);
                    this.downloadLoading = false;
                }
            }
        },
    },
});
